export default __webpack_public_path__ + "static/googleplay-icon-459db0534953ef0b2c9102fd6c54da38.png";